export const BRAND = {
  name: "The Window Place LLC",
  address: "1300 E 4th Ave",
  city: "Milbank, SD 57252",
  phone: "(605) 432-1834",
  tollFree: "(877) 224-0745",
  fax: "(605) 432-1837",
  website: "TheWindowPlaceLLC.com",
  email: "office@thewindowplacellc.com",
  logoUrl: "/brand/twp-logo.png",
  colors: {
    brown: "#8B4513",
    brownDark: "#6B3410",
    brownLight: "#A0522D",
    cream: "#faf7f3",
    dark: "#2b2b2b",
  }
};